import { render, staticRenderFns } from "./CompensationPointsRemove.vue?vue&type=template&id=a59808e0&scoped=true&"
import script from "./CompensationPointsRemove.vue?vue&type=script&lang=js&"
export * from "./CompensationPointsRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59808e0",
  null
  
)

export default component.exports